var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollarQuadro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_828_2428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.833313V19.1666M14.1667 4.16665H7.91667C7.14312 4.16665 6.40125 4.47394 5.85427 5.02092C5.30729 5.5679 5 6.30976 5 7.08331C5 7.85686 5.30729 8.59873 5.85427 9.14571C6.40125 9.69269 7.14312 9.99998 7.91667 9.99998H12.0833C12.8569 9.99998 13.5987 10.3073 14.1457 10.8543C14.6927 11.4012 15 12.1431 15 12.9166C15 13.6902 14.6927 14.4321 14.1457 14.979C13.5987 15.526 12.8569 15.8333 12.0833 15.8333H5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_828_2428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollarQuadro);
export default __webpack_public_path__ + "static/media/icon-dollar-quadro.8c8aa540ebd5eab7eda0349119cd9d2a.svg";
export { ForwardRef as ReactComponent };